import { useEffect } from 'react';
import { configureDomPurify } from '@trip-ux/common';

export const useDomPurify = (
  contextPath: string,
  effectiveIsAdmin: boolean,
  currentLocale: string,
  newTabAriaLabel: string
) => {
  useEffect(() => {
    if (!effectiveIsAdmin) {
      configureDomPurify(contextPath, newTabAriaLabel);
    }
  }, [contextPath, effectiveIsAdmin, currentLocale, newTabAriaLabel]);
};
